import { render, staticRenderFns } from "./ImportRacers.vue?vue&type=template&id=3222f5f7"
import script from "./ImportRacers.vue?vue&type=script&lang=js"
export * from "./ImportRacers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports